import {defineStore} from 'pinia'
import {useApiRequestStore} from '@toolify/client/src/stores/ApiRequestStore/useApiRequestStore'
import {
  IGetRingingCallInvitesRequestInterfaces,
} from '@toolify/server/src/controllers/CallInviteController/validators/GetRingingCallInvites/types/IGetRingingCallInvitesRequestInterfaces'
import {
  IAcceptCallInviteRequestInterfaces,
} from '@toolify/server/src/controllers/CallInviteController/validators/AcceptCallInvite/types/IAcceptCallInviteRequestInterfaces'
import {
  IDeclineCallInviteRequestInterfaces,
} from '@toolify/server/src/controllers/CallInviteController/validators/DeclineCallInvite/types/IDeclineCallInviteRequestInterfaces'
import {
  ICallInviteResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/ICallInviteResponseInstance'
import {mapCallInviteResponseInstance} from '@toolify/client/src/modules/api/singletons/mapCallInviteResponseInstance'

export const useCallInviteApiStore = defineStore('callInviteApi', {
  actions: {
    async getRingingCallInvites(): Promise<ICallInviteResponseInstance[]> {
      const apiRequestStore = useApiRequestStore()
      const {callInvites} = await apiRequestStore.get<IGetRingingCallInvitesRequestInterfaces>('/call-invites/ringing')
      return callInvites.map(callInvite => mapCallInviteResponseInstance(callInvite))
    },

    async acceptCallInvite(callInviteId: string): Promise<ICallInviteResponseInstance> {
      const apiRequestStore = useApiRequestStore()
      const {callInvite} = await apiRequestStore.post<IAcceptCallInviteRequestInterfaces>(`/call-invites/${callInviteId}/accept`)
      return mapCallInviteResponseInstance(callInvite)
    },

    async declineCallInvite(callInviteId: string): Promise<ICallInviteResponseInstance> {
      const apiRequestStore = useApiRequestStore()
      const {callInvite} = await apiRequestStore.post<IDeclineCallInviteRequestInterfaces>(`/call-invites/${callInviteId}/decline`)
      return mapCallInviteResponseInstance(callInvite)
    },
  },
})

